import React from 'react';

const Loading = () => {
    return (
        <div class="flex items-center justify-center ">
            <div class="w-24 h-24 border-l-2 border-red-700 rounded-full animate-spin"></div>
        </div>
    );
};

export default Loading;